import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { MatSnackBar } from "@angular/material";
import { HttpClient, HttpErrorResponse, HttpHeaders, } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router'
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { environment } from "../environments/environment";
import { MatDialog } from '@angular/material/dialog';
import { MsgboxComponent } from './msgbox/msgbox.component';


declare const loadBar: any;
declare const $;
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})

export class AppService {


  websiteUrl = "https://www.propira.com";
  //  ServerUrl = 'https://www.team.propira.com/api';
  // ServerUrl = 'http://192.168.1.3/propira_admin/api'; 
  ServerUrl = environment.sitUrl;

  errorData: {};

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'text/plain; charset=utf-8', 'Accept': 'application/json' })
  };

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private router: Router,
    private titleservice: Title,
    private metaservice: Meta) { }

  loaderStatus: boolean = true;
  redirectUrl: string = "/profile/myproperty";

  isLoggedIn() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('currentUser')) {
        return true;
      }
    }
    return false;
  }

  getAuthorizationToken() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return currentUser.auth_token;
    } else {
      return '0';
    }
  }

  get getSelectedCity() {
    var selCity = JSON.parse(localStorage.getItem('selSearchCity')); 
    if (selCity==null) {  
      var defaultCity={'categoryType':'buy','showCategoryLabel':'buy','id':'3297','name':'Alwar', 'slug':'alwar'};
      localStorage.setItem('selSearchCity', JSON.stringify(defaultCity));
      selCity = JSON.parse(localStorage.getItem('selSearchCity'));
    }
    return selCity;
  }

  get getPropertyWishlistId() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return currentUser.property_wishlistid;
    } else {
      return '0';
    }
  }

  get getPayingGuestWishlistId() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return currentUser.payingguest_wishlistid;
    } else {
      return '0';
    }
  }

  logout() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('currentUser');
      location.reload();
    }
  }

  setTitle(value: string) {
    this.titleservice.setTitle(value);
  }

  addTag(value: any) {
    this.metaservice.addTag(value);
  }

  setMetaTags(value: any) {
    this.metaservice.updateTag(value);
  }

  post(url, data) {
    return this.http.post<any>(this.ServerUrl + url, data, this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  get(url) {
    return this.http.get<any>(this.ServerUrl + url, this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  postMultipart(url, data) {

    this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', 'multipart/form-data');

    return this.http.post<any>(this.ServerUrl + url, data).pipe(
      catchError(this.handleError)
    );

  }

  private handleError(error: HttpErrorResponse) {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {

      // The backend returned an unsuccessful response code.

      // The response body may contain clues as to what went wrong.

      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }

    // return an observable with a user-facing error message

    this.errorData = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.'
    };

    return throwError(this.errorData);
  }

  convert_number(number) {
    if ((number < 0) || (number > 999999999)) {
      return "NUMBER OUT OF RANGE!";
    }
    var Gn = Math.floor(number / 10000000);  /* Crore */
    number -= Gn * 10000000;
    var kn = Math.floor(number / 100000);     /* lakhs */
    number -= kn * 100000;
    var Hn = Math.floor(number / 1000);      /* thousand */
    number -= Hn * 1000;
    var Dn = Math.floor(number / 100);       /* Tens (deca) */
    number = number % 100;               /* Ones */
    var tn = Math.floor(number / 10);
    var one = Math.floor(number % 10);
    var res = "";

    if (Gn > 0) {
      res += (this.convert_number(Gn) + " Crore");
    }
    if (kn > 0) {
      res += (((res == "") ? "" : " ") +
        this.convert_number(kn) + " Lakh");
    }
    if (Hn > 0) {
      res += (((res == "") ? "" : " ") +
        this.convert_number(Hn) + " Thousand");
    }

    if (Dn) {
      res += (((res == "") ? "" : " ") +
        this.convert_number(Dn) + " Hundred");
    }

    var ones = Array("", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen");
    var tens = Array("", "", "Twenty", "Thirty", "Fourty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety");

    if (tn > 0 || one > 0) {
      if (!(res == "")) {
        res += " AND ";
      }
      if (tn < 2) {
        res += ones[tn * 10 + one];
      }
      else {
        res += tens[tn];
        if (one > 0) {
          res += ("-" + ones[one]);
        }
      }
    }

    if (res == "") {
      res = "zero";
    }
    return res;
  }

  numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000) + ' Cr';
    else if (val >= 100000) val = (val / 100000) + ' Lac';
    else if (val >= 1000) val = (val / 1000) + ' K';
    return val;
  }


  successMsg(msg) {
    return '<p class="successMsg"><i class="ti-face-smile" aria-hidden="true" ></i>&nbsp;' + msg + '</p> ';
  }

  failedMsg(msg) {
    return '<p class="failedMsg"  ><i class="ti-face-sad" aria-hidden="true" ></i>&nbsp;' + msg + '</p>  ';
  }

  loadScript(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      const body = <HTMLDivElement>document.body;
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = url;
      script.async = false;
      script.defer = true;
      body.appendChild(script);
      return script;
    }
  }

  loadExternalStyles(styleUrl: string) {
    // Create link
    let link = document.createElement('link');
    link.href = styleUrl;
    link.rel = 'stylesheet';
    link.type = 'text/css';

    let head = document.getElementsByTagName('head')[0];
    let links = head.getElementsByTagName('link');
    let style = head.getElementsByTagName('style')[0];

    // Check if the same style sheet has been loaded already.
    let isLoaded = false;
    for (var i = 0; i < links.length; i++) {
      var node = links[i];
      if (node.href.indexOf(link.href) > -1) {
        isLoaded = true;
      }
    }
    if (isLoaded) return;
    head.insertBefore(link, style);
  }

  loading: boolean = true;
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true
    }
    if (event instanceof NavigationEnd) {
      this.loading = false
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false
    }
    if (event instanceof NavigationError) {
      this.loading = false
    }
  }

  getStateNameById(id) {
    return 'Rajasthan';
  }

  getCityNameById(id: any) {
    return 'Alwar';
  }

  getPossesionById(id) {
    var data = [
      { id: "1", value: "Ready Possession" },
      { id: "2", value: "Under construction" }
    ];

    var searchValue = data.filter(function (keyData) {
      return keyData.id == id;
    });

    if (searchValue.length > 0) {
      return searchValue[0].value;
    }
  }

  getUnitById(id) {
    var data = [
      { id: "1", value: "Amount" },
      { id: "2", value: "Sq. Ft." },
      { id: "3", value: "Sq. Yd." },
      { id: "4", value: "Sq. Mtr." },
      { id: "5", value: "Bigha" },
      { id: "6", value: "Acre" },
      { id: "7", value: "Hectare" },
      { id: "8", value: "Monthly" },
      { id: "10", value: "Biswa" },
      { id: "11", value: "Ares" }
    ];

    var searchValue = data.filter(function (keyData) {
      return keyData.id == id;
    });

    if (searchValue.length > 0) {
      return searchValue[0].value;
    }
  }

  getOwnershipById(id) {
    var data = [
      { id: "1", value: "Agreement" },
      { id: "2", value: "Registry" },
      { id: "3", value: "Socity Patta" },
      { id: "4", value: "Agriculture Patta" },
      { id: "5", value: "UIT (Urban Improvement Trust)" },
      { id: "6", value: "RHB (Rajasthan Housing Board)" },
      { id: "7", value: "RIICO" },
      { id: "8", value: "Registry by Builder" },
      { id: "9", value: "Other" },
    ];

    var searchValue = data.filter(function (keyData) {
      return keyData.id == id;
    });

    if (searchValue.length > 0) {
      return searchValue[0].value;
    }
  }

  notificationPopup(type, message: string) {
    this.snackBar.open(message, 'ok', {
      duration: 3000,
    });
  }

  messageBox(type, msg) {
    this.dialog.open(MsgboxComponent, {
      panelClass: 'custom-dialog-container',
      disableClose: true,
      data: { type: type, msg: msg }
    });
  }
  public sendEvents(
    eventCategory: string,
    eventLabel: string,
    eventAction: string,) {
    gtag('event', eventAction, {
      event_category: eventAction,
      event_label: eventLabel,
    })
  }

  chkLogin(mobile,otp,redirect='yes') {

    const login = {
      email_mobile:mobile,
      password_otp:otp,
      type:"Web"
    }
    console.log(login);

    this.post('/login',login).subscribe(data => {
    
    if (data[0].error == '0') {
        console.log(localStorage);
        localStorage.setItem('currentUser', JSON.stringify(data[0]));

        if(redirect=='yes'){

          var redirectUrl = this.redirectUrl;
          this.redirectUrl ='/';
          this.router.navigateByUrl(redirectUrl);

        }
        
      }
    },
    );
  }

  addToWishlist(property_type, property_id, event) {
    if (this.isLoggedIn()) {
      if (event.srcElement.classList.contains('fa-heart-o')) {
        event.srcElement.classList.remove('fa-heart-o');
        event.srcElement.classList.add('fa-heart');

        this.notificationPopup('success', 'Property successfully added in wishlist.');

      } else {
        event.srcElement.classList.remove('fa-heart');
        event.srcElement.classList.add('fa-heart-o');

        this.notificationPopup('success', 'Property successfully removed to wishlist.');
      }

      this.post('/addPropertyWishlist', { "type": "Web", "auth_token": this.getAuthorizationToken(), "property_type": property_type, "property_id": property_id }).subscribe(

        data => {
          if (data[0].error == '0') {

            var profileData = JSON.parse(localStorage.getItem('currentUser'));
            profileData.property_wishlistid = data[0].property_id;
            localStorage.setItem('currentUser', JSON.stringify(profileData));
          } else {
            this.messageBox('failed', 'Something went wrong.please try again.');
          }
        },
        error => {
          this.messageBox('failed', 'Something went wrong.please try again.');
        }
      )
    } else {
      $('#loginModal').modal('toggle');
    }

  }

  removejscssfile(filename, filetype){
    var targetelement=(filetype=="js")? "script" : (filetype=="css")? "link" : "none" //determine element type to create nodelist from
    var targetattr=(filetype=="js")? "src" : (filetype=="css")? "href" : "none" //determine corresponding attribute to test for
    var allsuspects=document.getElementsByTagName(targetelement)
    for (var i=allsuspects.length; i>=0; i--){ //search backwards within nodelist for matching elements to remove
    if (allsuspects[i] && allsuspects[i].getAttribute(targetattr)!=null && allsuspects[i].getAttribute(targetattr).indexOf(filename)!=-1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
  }

}

